module.exports = "pegasus_template/assets/themelp1/small/bg1.png";